/**
 * Builds optimistic embeds array for use case updates.
 * Filters out removed embeds and adds new embeds with calculated positions.
 *
 * @param {Object} params - Function parameters
 * @param {Object[]} params.originalEmbeds - Original embeds from the use case
 * @param {Object} params.mediaChanges - Object containing added and removed media
 * @param {Object[]} params.mediaChanges.added - Array of new media items to add
 * @param {string[]} params.mediaChanges.removed - Array of embed IDs to remove
 * @param {string} params.date - ISO date string for createdAt/updatedAt
 * @returns {Object[]} Array of optimistic embeds with positions
 */
export function buildOptimisticEmbeds({ originalEmbeds, mediaChanges, date }) {
  const remainingEmbeds = originalEmbeds.filter(
    embed => !mediaChanges.removed.includes(embed.id)
  )

  return [
    ...remainingEmbeds,
    ...mediaChanges.added.map((media, index) => ({
      ...media,
      thumbUrl: media.preview || media.thumbUrl || media.url || '',
      mediumUrl: media.preview || media.mediumUrl || media.url || '',
      largeUrl: media.preview || media.largeUrl || media.url || '',
      position: remainingEmbeds.length + index,
      createdAt: date,
      updatedAt: date,
    })),
  ]
}

/**
 * Calculates position for new embeds based on remaining embeds count.
 *
 * @param {number} remainingCount - Number of embeds remaining after removals
 * @param {number} index - Index of the new embed being added
 * @returns {number} The position for the new embed
 */
export function calculateEmbedPosition(remainingCount, index) {
  return remainingCount + index
}
